var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{staticClass:"view"},[_c('b-col',{attrs:{"md":"8","lg":"6","cols":"12"}},[_c('payway')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }